import React, { memo } from 'react'

import '../../../assets/styles/components/_forms.scss'

const Checkbox = memo(({ dashed, classes, label, ...rest }) => {

  const contentLabel = (dashed)
    ? <div className='checkbox-dashed'>{label}</div>
    : <div>{label}</div>

  return (
    <div className={`checkbox ${classes || ''}`}>
      <label htmlFor={rest.id}>
        <input
          type='checkbox'
          defaultChecked={rest.checked}
          checked={rest.value || false}
          {...rest}
        />
        <span>
          {contentLabel}
        </span>
      </label>
    </div>
  )
})

export default Checkbox
